// extracted by mini-css-extract-plugin
export default {"worldTopSection":"World_worldTopSection__j2YcZ","worldPage":"World_worldPage__4fMuD"};